import React, { useState, useEffect, Fragment } from "react";
import {
  IonAlert,
  IonAvatar,
  IonButton,
  IonCard,
  IonCardContent,
  IonCol,
  IonIcon,
} from "@ionic/react";

import "./UserMessageCard.scss";
import _ from "lodash";
import { CONSTANTS } from "../../../constants/callcentral.constants";
import {
  checkmarkCircleSharp,
  closeCircleSharp,
  removeCircleSharp,
} from "ionicons/icons";
import { doctorCardService } from "../DoctorList/Components/DoctorCard/doctor-card-service";
import { ShiftTime } from "../DoctorList/Components/DoctorCard/doctor-card.model";

/**
 * User Messaage Card
 * Component will show a drop down to select from list.
 * Component will return the selectd item id.
 */

interface DropDownItemProps {
  doctorData: any;
  removedUser: (data: any) => void;
  isFromHomeMessage?: boolean;
}

const UserMessageCard: React.FC<DropDownItemProps> = (props) => {
  const [isShowAlert, setIsShowAlert] = useState(false);
  const componentName: any = CONSTANTS.COMPONENTS.ONCALL_LOOK_UP;
  const [checked, showShiftData] = useState(false);
  const [hideMoreButton, setHideMoreButton] = useState(false);
  const [hideLessButton, setHideLessButton] = useState(false);
  const [uniqueShifts, setUniqueShifts]: any = useState([]);

  useEffect(() => {
    if (props.doctorData?.shiftTime) {
      const uniqueShifts = _.uniqBy(props.doctorData.shiftTime, "startTime");
      setUniqueShifts(uniqueShifts);
    }
  }, [props.doctorData]);

  const handelRemoveUser = () => {
    props.removedUser(props.doctorData);
  };

  const mapSpecialityDetails = (speciality: any) => {
    if (!_.isEmpty(speciality)) {
      return speciality.toString();
    } else {
      return "";
    }
  };

  let hideSpeciality = false;

  return (
    <IonCol
      className="base-column-user-card"
      size="12"
      size-lg={props.isFromHomeMessage ? "4" : "6"}
    >
      <IonAlert
        isOpen={isShowAlert}
        onDidDismiss={() => setIsShowAlert(false)}
        cssClass="doctor-card-alert"
        header="Confirmation!"
        message={CONSTANTS.MESSAGES.REMOVE_USER_CONFIRMATION}
        buttons={[
          {
            text: "NO",
            role: "cancel",
            cssClass: "secondary",
          },
          {
            text: "YES",
            handler: () => {
              handelRemoveUser();
              setIsShowAlert(false);
            },
          },
        ]}
      />

      <IonCard className="ion-message-card-wrapper">
        <IonCardContent>
          <div
            id={`doctor-card-${props.doctorData.guid}`}
            className="doctor-card"
          >
            <div className="doctor-card-wrapper">
              <div className="profile-pic-div">
                <IonAvatar className="doctor-profile-div">
                  <img
                    src={props!.doctorData.profilePic}
                    alt="Ionic logo"
                    className="doctor-profile-image"
                  />
                  <div className="show-badge">
                    {props!.doctorData.onGoing && (
                      <div className="online-icon-div" title="Oncall">
                        <IonIcon icon={checkmarkCircleSharp} />
                      </div>
                    )}
                    {!_.isEmpty(props.doctorData.templateAvailability) &&
                      !props.doctorData.onGoing && (
                        <div
                          className="template-availablity-icon-div"
                          title="Available, but not on-call"
                        >
                          <IonIcon icon={removeCircleSharp} />
                        </div>
                      )}
                    {!props.doctorData.onGoing &&
                      _.isEmpty(props.doctorData.templateAvailability) && (
                        <div className="not-on-going-div" title="Not On-call">
                          <IonIcon icon={closeCircleSharp} />
                        </div>
                      )}
                  </div>
                </IonAvatar>
              </div>

              <div className="doctor-details">
                <div
                  id={`doctor-details-div-${props.doctorData.guid}`}
                  className="doctor-details-div"
                >
                  <div className="doctor-name">
                    <div className="doctor-name-label">
                      {props.doctorData.firstName} {props.doctorData.lastName}
                    </div>
                  </div>
                </div>
                {_.isEmpty(props.doctorData.shiftTime) && (
                  <Fragment>
                    <div className="no-shift-speciality-details">
                      {mapSpecialityDetails(props.doctorData.speciality)}
                    </div>
                    <div>
                      {!_.isEmpty(props.doctorData.templateAvailability) &&
                        componentName !== CONSTANTS.COMPONENTS.GROUP_SMS && [
                          <div className="not-oncall-div">
                            {!props.doctorData.onGoing &&
                              componentName ===
                                CONSTANTS.COMPONENTS.ONCALL_LOOK_UP && (
                                <div>Not On-Call</div>
                              )}
                          </div>,
                          <div
                            className={`availability-div ${
                              _.isEmpty(props.doctorData.shiftTime) &&
                              "availability-div-no-shift"
                            }`}
                          >
                            Available At{" "}
                            {doctorCardService.availabilityTimeFormat(
                              props.doctorData.templateAvailability!.startTime
                            )}{" "}
                            --{" "}
                            {doctorCardService.availabilityTimeFormat(
                              props.doctorData.templateAvailability!.endTime
                            )}
                          </div>,
                        ]}
                    </div>
                  </Fragment>
                )}
                {props.doctorData?.shiftTime?.length > 0 && (
                  <div>
                    <div>
                      <div className="speciality-details">
                        <div>
                          {doctorCardService.specialityTrim(
                            props.doctorData.shiftTime[0].group.speciality
                          )}
                        </div>
                      </div>
                      <div className="shift-details">
                        <div>
                          {props.doctorData.shiftTime[0].startTime} -{" "}
                          {props.doctorData.shiftTime[0].endTime}
                        </div>
                      </div>
                    </div>
                    <div>
                      {!_.isEmpty(props.doctorData.templateAvailability) &&
                        props.doctorData?.shiftTime?.length === 1 &&
                        componentName !== CONSTANTS.COMPONENTS.GROUP_SMS && [
                          <div className="not-oncall-div">
                            {!props.doctorData.onGoing &&
                              componentName ===
                                CONSTANTS.COMPONENTS.ONCALL_LOOK_UP && (
                                <div>Not On-Call</div>
                              )}
                          </div>,
                          <div
                            className={`availability-div ${
                              _.isEmpty(props.doctorData.shiftTime) &&
                              "availability-div-no-shift"
                            }`}
                          >
                            Available At{" "}
                            {doctorCardService.availabilityTimeFormat(
                              props.doctorData.templateAvailability!.startTime
                            )}{" "}
                            --{" "}
                            {doctorCardService.availabilityTimeFormat(
                              props.doctorData.templateAvailability!.endTime
                            )}
                          </div>,
                        ]}
                    </div>
                  </div>
                )}
                {props.doctorData?.shiftTime?.length > 1
                  ? [
                      <div
                        id={`more-button-div-${props.doctorData.guid}`}
                        className="more-button-div align-more-button"
                      >
                        {componentName !== CONSTANTS.COMPONENTS.GROUP_SMS && (
                          <IonButton
                            className={
                              hideMoreButton ? "hide-display" : "more-button"
                            }
                            onClick={() => {
                              showShiftData(true);
                              setHideMoreButton(true);
                              setHideLessButton(false);
                              doctorCardService.increaseDoctorCardHeight(
                                props.doctorData
                              );
                            }}
                          >
                            + more
                          </IonButton>
                        )}
                      </div>,
                      <div className={hideMoreButton ? "hide-display" : ""}>
                        {!_.isEmpty(props.doctorData.templateAvailability) &&
                          componentName !== CONSTANTS.COMPONENTS.GROUP_SMS && [
                            <div className="not-oncall-div">
                              {!props.doctorData.onGoing &&
                                componentName ===
                                  CONSTANTS.COMPONENTS.ONCALL_LOOK_UP && (
                                  <div>Not On-Call</div>
                                )}
                            </div>,
                            <div
                              className={`availability-div ${
                                _.isEmpty(props.doctorData.shiftTime) &&
                                "availability-div-no-shift"
                              }`}
                            >
                              Available At{" "}
                              {doctorCardService.availabilityTimeFormat(
                                props.doctorData.templateAvailability!.startTime
                              )}{" "}
                              --{" "}
                              {doctorCardService.availabilityTimeFormat(
                                props.doctorData.templateAvailability!.endTime
                              )}
                            </div>,
                          ]}
                      </div>,
                      <div>
                        {checked
                          ? uniqueShifts.slice(1).map((item: ShiftTime) => {
                              if (
                                item.group.speciality ===
                                props.doctorData.shiftTime[0].group.speciality
                              ) {
                                hideSpeciality = true;
                              }
                              return (
                                <div>
                                  {hideSpeciality ? null : (
                                    <div className="speciality-details">
                                      <div>
                                        {doctorCardService.specialityTrim(
                                          item.group.speciality
                                        )}
                                      </div>
                                    </div>
                                  )}

                                  <div className="shift-details">
                                    <div>
                                      {item.startTime} - {item.endTime}
                                    </div>
                                  </div>
                                </div>
                              );
                            })
                          : null}
                        {checked
                          ? [
                              <div
                                id={`less-button-div-${props.doctorData.guid}`}
                                className="less-button-div"
                              >
                                <IonButton
                                  className={
                                    hideLessButton
                                      ? "hide-display"
                                      : "less-button"
                                  }
                                  onClick={() => {
                                    showShiftData(false);
                                    setHideLessButton(true);
                                    setHideMoreButton(false);
                                    doctorCardService.decreaseDoctorCardHeight(
                                      props.doctorData
                                    );
                                  }}
                                >
                                  - less
                                </IonButton>
                              </div>,
                              <div>
                                {!_.isEmpty(
                                  props.doctorData.templateAvailability
                                ) && [
                                  <div className="not-oncall-div">
                                    {!props.doctorData.onGoing &&
                                      componentName ===
                                        CONSTANTS.COMPONENTS.ONCALL_LOOK_UP && (
                                        <div>Not On-Call</div>
                                      )}
                                  </div>,
                                  <div
                                    className={`availability-div ${
                                      _.isEmpty(props.doctorData.shiftTime) &&
                                      "availability-div-no-shift"
                                    }`}
                                  >
                                    Available At{" "}
                                    {doctorCardService.availabilityTimeFormat(
                                      props.doctorData.templateAvailability!
                                        .startTime
                                    )}{" "}
                                    --{" "}
                                    {doctorCardService.availabilityTimeFormat(
                                      props.doctorData.templateAvailability!
                                        .endTime
                                    )}
                                  </div>,
                                ]}
                              </div>,
                            ]
                          : null}
                      </div>,
                    ]
                  : null}
              </div>

              <div className="doctor-icon-wrapper">
                <div
                  title="Delete"
                  className="close-icon-div"
                  onClick={(e) => e.stopPropagation()}
                >
                  <div
                    className="input-icon icon-close"
                    onClick={() => setIsShowAlert(true)}
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </IonCardContent>
      </IonCard>
    </IonCol>
  );
};

export default UserMessageCard;
